import { render, staticRenderFns } from "./OctCustomerCard.vue?vue&type=template&id=7c7185f8&scoped=true&"
import script from "./OctCustomerCard.vue?vue&type=script&lang=js&"
export * from "./OctCustomerCard.vue?vue&type=script&lang=js&"
import style0 from "./OctCustomerCard.vue?vue&type=style&index=0&id=7c7185f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7185f8",
  null
  
)

export default component.exports